<template>
    <v-card class="mx-4">
      <v-layout class="buttons" justify-end row align-center>
        <v-btn
          class="TierButton mb-1 mr-0 ml-1"
          @click="openCreateUserForm()"
        >
          + New User
        </v-btn>
      </v-layout>
      <v-data-table
          :headers="headers"
          :items="users"
          :item-key="users.Id"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
          :loading="loading"
          :total-items="totalRecords"
          @update:pagination="paginationUpdated"
          hide-details
          class="striped-table no-pagination-btn">
        <template slot="items" slot-scope="props">
          <tr :key="props.index"
              :class="{'': props.item.IsEnabled , 'DisabledUser': !props.item.IsEnabled }"
          >
            <td class="text-xs-left mx-0 pr-0">{{ props.item["Username"] }}</td>
            <td class="text-xs-left mx-0 pr-0">{{ props.item["FirstName"] }}</td>
            <td class="text-xs-left mx-0 pr-0">{{ props.item["LastName"] }}</td>
            <td class="text-xs-left mx-0 pr-0">{{ props.item["IsEnabled"] == true ? "YES" : "NO" }}</td>
            <td class="text-xs-left mx-0 pr-0">{{ formatDate(props.item["ExpirationDate"]) }}</td>
            <td class="text-xs-left mx-0 pr-0">{{ daysRemaining(props.item["ExpirationDate"]) }}</td>
            <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
              <a class="mr-0" style="text-decoration: none"
                  @click="openEditUserForm(props.item)">
                EDIT
              </a>
            </td>
          </tr>
        </template>
        <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
      </v-data-table>
      <createUser ref="createUser" @parentRefresh="paginationUpdated"></createUser>
    </v-card>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import Bus from "../../bus";
import zigZag from "../../components/ZigZag.vue";
import * as helper from "../../helpers/global.js";
import createUser from "./CreateUser.vue";
import moment from "moment";
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "UserManagement",

  components: {
    VPage,
    zigZag,
    createUser,
    DataTablePagination
  },

  data: () => ({
    users: [],
    loading: false,
    totalRecords: 0,
    filters: {},
    search: "",
    selectedRow: null,

    // Selected by default
      pagination: {
        rowsPerPage: 10,
        descending: true,
        totalRecords: 0,
        sortBy: "Email",
        page: 1,
      },

      rowsPerPageItems: [
        5,
        10,
        30,
        {
          text: "$vuetify.dataIterator.rowsPerPageAll",
          value: -1
        }
      ],

      headers:[
        {
          text: "Username",
          value: "Username",
          width: "22%",
          fixed: true,
          align: "left",
          class: "pl-0 pr-0 font-weight-bold subheading"
        },
        {
          text: "First Name",
          value: "FirstName",
          width: "17%",
          fixed: true,
          align: "left",
          class: "pl-0 pr-0 font-weight-bold subheading"
        },
        {
          text: "Last Name",
          value: "LastName",
          width: "17%",
          fixed: true,
          align: "left",
          class: "pl-0 pr-0 font-weight-bold subheading"
        },
        {
          text: "Enabled",
          value: "IsEnabled",
          width: "7%",
          fixed: true,
          align: "left",
          class: "pl-0 pr-0 font-weight-bold subheading"
        },
        {
          text: "Expires",
          value: "ExpirationDate",
          width: "17%",
          fixed: true,
          align: "left",
          class: "pl-0 pr-0 font-weight-bold subheading"
        },
        {
          text: "Days Left",
          width: "10%",
          fixed: true,
          align: "left",
          class: "pl-0 pr-0 font-weight-bold subheading"
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "10%",
          fixed: true,
          align: "right",
          class: "font-weight-bold subheading text-align-right justify-end pr-0"
        },
      ],
  }),
  created(){
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },
  destroyed(){
    this.$root.$off("initialize", this.initialize);
  },
  mounted(){
    
  },
  methods: {
    async initialize(){
      this.filters = {};
      this.selectedRow = null;
      
      this.paginationUpdated();

    },
    async paginationUpdated(){
      this.loading = true
      await axios.post('/api/User/GetPagedUserList/', 
        { 
          "postData": {
              "pagination" : this.pagination, 
              "filters": this.filters,
              "search": this.search
              }
        },
        {
          headers: {
            'Content-type' : 'application/json',
          }
        })
        .then((response) => {
          this.users = response.data.users
          this.totalRecords = response.data.totalRecords
        })
      this.loading = false;
    },
    async openEditUserForm(item)
    {
      let index = this.users.indexOf(item);
      if (index > -1){
        this.selectedRow = this.users[index].Id;
      }
      await this.$refs.createUser.close();
      this.$refs.createUser.openEdit(this.users[index]);
    },
    async openCreateUserForm()
    {
      await this.$refs.createUser.close();
      this.$refs.createUser.open();
    },
    formatDate(value){
        if(value)
          return moment(value).format('YYYY-MM-DD HH:mm:ss UTC Z')
        else
          return '';
    },
    daysRemaining(value){
      var a = moment(value);
      var b = moment();

      return a.diff(b,'days');
    },
  },
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}

.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}

.DisabledUser {
  background-color: pink!important;
}
</style>
